import { takeLatest, put, call } from 'redux-saga/effects';

import { listAnimalRacaCadastro } from '../service';
import {
    TABLE_ANIMAL_RACA_CADASTRO,
    TABLE_ANIMAL_RACA_CADASTRO_PENDING,
    TABLE_ANIMAL_RACA_CADASTRO_SUCCESS,
    TABLE_ANIMAL_RACA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListAnimalRacaCadastro(action) {
  yield put({ type: TABLE_ANIMAL_RACA_CADASTRO_PENDING })

  try {
    const table = yield call(listAnimalRacaCadastro, action.args)
    yield put({ type: TABLE_ANIMAL_RACA_CADASTRO_SUCCESS, table: table })
  } catch (error) {
    yield put({ type: TABLE_ANIMAL_RACA_CADASTRO_FAILURE })
  }
}

export default function* watchListAnimalRacaCadastro() {
  yield takeLatest(TABLE_ANIMAL_RACA_CADASTRO, sagaListAnimalRacaCadastro)
}